import Endpoints from '@/config/ApiEndpoints.js';
import Axios from 'axios';
import $ from 'jquery';
import UpcomingEvent from '@/pages/upcomingevent/upcomingevent';
import DriverProfilePicture from '@/pages/drivers/driverprofilepicture/driverprofilepicture';
import DriverTag from '@/pages/drivers/drivertag/drivertag';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import SetRandomColors from "@/assets/js/random_color.js";
import Task from "@/pages/task/task";
import SendMessage from "@/pages/send_custom_notification/sendmessage";

import DriverAssetsPopup from '@/pages/vehicles/vehicleassetpopup/vehicleassetpopup.vue';
var moment = require("moment");
export default {
	components:{
		UpcomingEvent,
		VuePerfectScrollbar,
		DriverProfilePicture,
		DriverTag,
		SendMessage,
		Task,
		DriverAssetsPopup
	},
	filters: {
        date: function(data) {
			var sendDate = "N/A";
			if (data != "" && data != null) {
			sendDate = moment(data).format("MM-YYYY");
			}
			return sendDate;
        }
    },
	data() {
		return {
			settings4: {
				maxScrollbarLength: 60,
				suppressScrollY: true,
			},
			ShowLoader: false,
			QuickShowLoader: false,
			showTableLoader:false,
			ShowVehicleAssetsModel:false,
			SearchKey: '',
			ScreenWidth:2,
			ImageEndpoint: Endpoints.Helper.GenerateImage+ '/',
			Drivers:[],
			QuickDrivers:[],
			Vehicles:[],
			AssginVehicle:{'driver_id':0,'vehicle_id':0},
			UpcomingEvent: {},
			DashboardData: {},
			DashboardReport:{},
			DashboardReportData:{},
			DashboardDetailHeading:'',
			DriverColor:[],
			driver_export_data:[],
			Branches:{},
			excel_data: [],
			excel_title: "",
			hgvModule:false,
			SearchData:{
				branch_id : "",
				vehicle_status : "",
				vehicle_assigned : "",
				points : "",
				CPC : "",
				ADR : "",
				connect_via_mobile:"",
				status:"1"
			},
			ActivityPage: 1,
			LastPageRequest: 0,
			FleetSubscription:[],
			ShowUrgentTask:false,
			ShowDriverDetails:false,
			SelectedDrivers:[],
			NotificationHeading:"",
			ShowNotifications: false,
			todaysUrgentTaskNew: window.todaysUrgentTaskNew,
			assetsModule: false,
			AssetsList:[],
		}
	},
	mounted() {
		var AccountPermissions = JSON.parse(
		localStorage.getItem("AccountPermissions")
		);
		this.FleetSubscription = JSON.parse(
		localStorage.getItem("FleetSubscription")
		);
		var FleetSubscriptionModules = JSON.parse(
		this.FleetSubscription.fleet_modules
		);
		if(FleetSubscriptionModules["Hierarchy System"] && (!AccountPermissions.Driver || !AccountPermissions.Driver.enable)){
		this.$router.push('/');
		}
		if (AccountPermissions && 
			AccountPermissions.Driver &&
			AccountPermissions.Driver.enable) {
			if (AccountPermissions.Driver.view) {
				this.ShowDriverDetails = true;
			}
		}

		if (AccountPermissions && 
			AccountPermissions['Vehicle Checks'] &&
			AccountPermissions['Vehicle Checks']['enable']) {
			if ( AccountPermissions['Vehicle Checks']['view_urgent_task']) {
				this.ShowUrgentTask = true;
			}
		}

		this.ShowNotifications = (FleetSubscriptionModules["Notifications"]);

		if (!FleetSubscriptionModules["Hierarchy System"]) {
			this.ShowUrgentTask = true;
		}

		var Company = JSON.parse(localStorage.getItem("Company"));
	    if (Company && Company.name) {      
		  if(window.taskModuleCompanies.includes(Company.id)){    
	      	this.todaysUrgentTaskNew = true
	      }
	    }

		document.title = pbx_SiteTitle+' - Drivers List';
		this.GetDashBoardReport();
		this.GetDriversList();
		this.GetVehiclesListForAssign();
		//this.GetUpcomingEventList();
		this.GetBranches();
		this.GetCompanySubscription();
		$('.closeDashboardDetail').on('click', function(event) {
			$("#DashboardDetailPopup").hide();
		})

	},	
	created() {
		//window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		//window.removeEventListener('scroll', this.handleScroll);
	},	
	methods : {
		exportActionNeeded() {
	      this.$refs.upcoming_events2.exportActionNeeded();
	    },
	    exportUrgentTask() {
	      this.$refs.urgent_task.exportActionNeeded();
	    },
		setDriver(driverID, driverName){
			this.SelectedDrivers = [];
			this.SelectedDrivers.push(driverID);
			this.NotificationHeading = driverName;
		},
		messageSent() {
			this.SelectedDrivers = [];
		},
		handleScroll() {
			let scrollBottom = document.body.scrollHeight;
			let bottomOfWindow = scrollBottom >= window.scrollY;
			if (bottomOfWindow) {
				this.GetDriversList();
			}
		},
		GetCompanySubscription(){
			var FleetSubscriptionModules = JSON.parse(
				JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
			  );
			  const isHGV = FleetSubscriptionModules.HGV;
			if (isHGV) {
			this.hgvModule = true;
			}			
			const isAsset = FleetSubscriptionModules.Assets;
			if (isAsset) {
				this.assetsModule = true;
			}
		},
		GetBranches(){
			var obj = { token: localStorage.getItem("token"), select_branch: true };
			Axios.post(Endpoints.Branch.List, obj).then((Response) => {
				if (Response?.data?.success) {
				this.Branches = Response.data.records;
				}
			});
		},
		checkDate(expDate){
			// set current date
			var currentDate = new Date();
			var licenceExpDate = new Date(expDate);
			var isLicenceExpired = false;
			if(licenceExpDate < currentDate){
				isLicenceExpired = true;
			}
			return isLicenceExpired;
		},
		ShowDashboardReportDetail(type) {
			this.driverfitList = false;
			this.driverunfitList = false;
			this.showTableLoader = true;
	  
			if (type == "driverfit") {
			  this.DashboardReportData.FitDriverArr = [];
			  this.DashboardDetailHeading = "Authorised To Drive Driver List";
			  this.driverfitList = true;
			}
			if (type == "driverunfit") {
			  this.DashboardReportData.UnfitDriverArr = [];
			  this.DashboardDetailHeading = "Unauthorised To Drive Driver List";
			  this.driverunfitList = true;
			}
			
			this.ShowDashboardDetailPopup = true;
	  
			Axios.post(Endpoints.Dashboard.DashboardReportData, {
			  token: localStorage.getItem("token"),
			  type: type,
			}).then((Response) => {
			  if (Response?.data?.success) {
				this.DashboardReportData = Response.data.DashboardReportData;
				this.showTableLoader = false;
				this.excel_data = [];
				if (type == "driverfit") {
					if (this.DashboardReportData.FitDriverArr.length > 0) {
					  this.DashboardReportData.FitDriverArr.forEach((element) => {
						var obj = {};
						obj["Driver"] = element.forename + " " + element.surname;
						this.excel_data.push(obj);
					  });
					}
					this.excel_title = "driver-fit-list";
				  }
				  if (type == "driverunfit") {
					if (this.DashboardReportData.UnfitDriverArr.length > 0) {
					  this.DashboardReportData.UnfitDriverArr.forEach((element) => {
						var obj = {};
						obj["Driver"] = element.forename + " " + element.surname;
						obj["Reason"] = element.unfit_reason;
						this.excel_data.push(obj);
					  });
					}
					this.excel_title = "driver-unfit-list";
				  }
			  }
			});
		  },
		GetDashBoardReport() {
			Axios.post(Endpoints.Dashboard.DashboardReport, {
			  token: localStorage.getItem("token"),
			  type: "driver"
			}).then((Response) => {
			  if (Response?.data?.success) {
				this.DashboardReport = Response.data.DashboardReport;
			  }
			});
		},
		SearchDriver(){
			this.Drivers = [];
			this.ActivityPage = 1;
			this.LastPageRequest = 0;
			this.GetDriversList('search')
		},
		GetDriversList(type=''){
			var self = this;
      		if (this.ActivityPage > 0 && this.LastPageRequest != this.ActivityPage) {
				this.SearchLoader = true;
				this.LastPageRequest = this.ActivityPage;
				var obj = {
				token: localStorage.getItem("token"),
				};
				if(type=='search'){
					if(this.SearchKey != ""){
						obj.searchkey = this.SearchKey
					}
					obj.SearchData = this.SearchData;
				}
				this.ShowLoader=true;
				Axios.post(Endpoints.Driver.List, obj).then((Response) => {
					this.ShowLoader=false;
					if (Response?.data?.success) {
						this.Drivers = Response.data.drivers;
						this.DriverColor = SetRandomColors(this.Drivers);
						if(screen.width < 1600){
							this.ScreenWidth = 1;
						}

						this.driver_export_data = [];
						if (this.Drivers.length > 0) {
							this.Drivers.forEach((element2) => {
							var obj = {};
							obj["Name"] = element2.forename+' '+element2.surname;
							obj["Phone"] = element2.phone;
							obj["Email"] = element2.email;
							obj["Penalty Point"] = element2.penality_points;
							obj["Licence Exp"] = this.$options.filters.date(element2.license_expiry);
							this.driver_export_data.push(obj);
						});
						}
					}
				});
			}
		},
		GetVehiclesListForAssign(){
			var obj={token: localStorage.getItem('token')}
			Axios.post(Endpoints.Vehicle.ListForAssign, obj).then((Response) => {
				if (Response?.data?.success) {
					this.Vehicles = Response.data.vehicles
				}
			})
		},
		DeleteDriver(driver_id) {
			this.$swal.fire({
				title: 'Are you sure You want to delete this Driver?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#514b71',
				cancelButtonColor: '#aaa',
				confirmButtonText: 'Yes, delete it!',
				reverseButtons: true,
			}).then((result) => {
				if (result.isConfirmed) {
					this.$swal.fire({
						title: 'Deleting...',
						text: 'Please wait...',

						showConfirmButton: false,
						allowOutsideClick: false,
					});
					Axios.post(Endpoints.Driver.Delete, {token: localStorage.getItem('token'),id: driver_id}).then((Response) => {
						if (Response?.data?.success == true) {
							this.GetDriversList();
							this.GetVehiclesListForAssign();
							this.$swal.fire('Driver Deleted Successfully','','success').then(() => {});
						} else {
							this.$swal.fire('Error:' + Response?.data?.message || "Something went wrong",'','error').then(() => {});
						}
					});
				}
			});
		},
		UnAssignVehicle(vehicle_link_id){
			this.$swal.fire({
				title: 'Are you sure You want to UnAssign this Vehicle?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#514b71',
				cancelButtonColor: '#aaa',
				confirmButtonText: 'Yes, UnAssign it!',
				reverseButtons: true,
			}).then((result) => {
				if (result.isConfirmed) {
					this.$swal.fire({
						title: 'Deleting...',
						text: 'Please wait...',

						showConfirmButton: false,
						allowOutsideClick: false,
					});
					Axios.post(Endpoints.Driver.UnAssginVehicle, {token: localStorage.getItem('token'),vehicle_link_id:vehicle_link_id}).then((Response) => {
						if (Response?.data?.success == true) {
							this.GetDriversList();
							this.GetVehiclesListForAssign();
							this.$swal.fire('Vehicle UnAssigned Successfully','','success').then(() => {});
						} else {
							this.$swal.fire('Error:' + Response?.data?.message || "Something went wrong",'','error').then(() => {});
						}
					});
				}
			});
		},
		AssignVehicle(driver_id){
			this.AssginVehicle.driver_id = driver_id
			this.AssginVehicle.vehicle_id = 0
		},
		SubmitAssignVehicle(){
			this.$swal.fire({
				title: 'Assigning...',
				text: 'Please wait...',

				showConfirmButton: false,
				allowOutsideClick: false,
			});

			if(this.AssginVehicle.vehicle_id > 0 && this.AssginVehicle.driver_id > 0){
				Axios.post(Endpoints.Driver.AssginVehicle, {token: localStorage.getItem('token'),driver_id:this.AssginVehicle.driver_id,vehicle_id:this.AssginVehicle.vehicle_id}).then((Response) => {
					if (Response?.data?.success == true) {
						this.GetDriversList();
						this.GetVehiclesListForAssign();
						$('#AssignVehicleModel .btn-close').trigger('click');
						this.$swal.fire('Vehicle Assigned Successfully','','success').then(() => {});
					} else {
						this.$swal.fire('Error:' + Response?.data?.message || "Something went wrong",'','error').then(() => {});
					}
				});
			}else{
				this.$swal.fire({
					'icon':'error',
					'title': 'Please Select Vehicle',
				});
			}
		},
		GetUpcomingEventList(){
			Axios.post(Endpoints.Dashboard.UpcomingEvent, {token: localStorage.getItem('token'),'RequestFor':'DriverList'}).then((Response) => {
				if (Response?.data?.success) {
					this.UpcomingEvent = Response.data.upcoming_event
				}
			})
		},
		ShowDashboardDetail(type){
			$(".DashboardDetailList").hide();
			if(type=='vehiclesafe'){
				this.DashboardDetailHeading='Safe To Drive Vehicle List';
				$(".vehiclesafeList").show();
			}
			if(type=='vehicleunsafe'){
				this.DashboardDetailHeading='Un-Safe To Drive Vehicle List';
				$(".vehicleunsafeList").show();
			}
			if(type=='driverfit'){
				this.DashboardDetailHeading='Fit To Drive Driver List';
				$(".driverfitList").show();
			}
			if(type=='driverunfit'){
				this.DashboardDetailHeading='Un-fit To Drive Driver List';
				$(".driverunfitList").show();
			}
			$("#DashboardDetailPopup").show();
		},
		showDriverAssetsModel(AssetList){
		this.AssetsList = AssetList;
		this.ShowVehicleAssetsModel = true;   
		setTimeout(() => {
			this.$refs.VehicleAssetsPopups.ShowVehicleAssetPopup()
		},500);   
		},
	}
}
